import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
const PositionManagerWithdrawLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-md flex flex-col"><div className="gap-xs flex flex-col"><div className="flex flex-row justify-between"><Skeleton className="h-[26px] w-[170px] rounded-[20px]" /><Skeleton className="h-[26px] w-20 rounded-[20px]" /></div><Skeleton className="h-[87px] w-[100%] rounded-[20px]" /></div><Skeleton className="h-[184px] w-[100%] rounded-[20px]" /><Skeleton className="h-[48px] w-[100%] rounded-lg" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PositionManagerWithdrawLoading;